import { render, staticRenderFns } from "./ActionCheckDeactivatedNumbers.vue?vue&type=template&id=10c771e8&scoped=true&"
import script from "./ActionCheckDeactivatedNumbers.vue?vue&type=script&lang=js&"
export * from "./ActionCheckDeactivatedNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ActionCheckDeactivatedNumbers.vue?vue&type=style&index=0&id=10c771e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c771e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
